import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./confirm-delete-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./confirm-delete-modal.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../../constants/shared.constants";
export let ConfirmDeleteModalComponent = class ConfirmDeleteModalComponent {
    activeModalService;
    label;
    dialogTitle;
    deleteConfirmationText;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    deleteBtnPlaceholder = SharedConstants.DELETE_LABEL;
    constructor(activeModalService) {
        this.activeModalService = activeModalService;
    }
    ngOnInit() {
        this.dialogTitle = `Delete ${this.label}`;
        this.deleteConfirmationText = `Are you sure you want to delete the selected ${this.label}?`;
    }
    onBtnCancelClicked() {
        this.activeModalService.close();
    }
    onBtnDeleteClicked() {
        this.activeModalService.close(true);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        label: [{ type: Input }]
    };
};
ConfirmDeleteModalComponent = __decorate([
    Component({
        selector: "app-confirm-delete-modal",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ConfirmDeleteModalComponent);
